export const CUSTOMERIO_BASE_PROPS = {
  platform: "website",
} as const;

export const CUSTOMERIO_SIGNUP_EVENT = "User Signed Up Website";
